import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireEventemitter3 } from "/home/luigi/eventemitter3/index.js";
var eventemitter3Exports = requireEventemitter3();
export { eventemitter3Exports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(eventemitter3Exports);